import React from 'react'
import bg from '../../img/parts/start_bg.png'

const Background = () => {
  return (
    <div>
      <img
        src={bg}
        alt="background"
        className="absolute hidden h-screen w-screen lg:block xl:block"
        style={{ position: 'fixed' }}
      />

      <img
        src={bg}
        alt="background"
        className="absolute h-screen w-screen bg-fixed object-cover md:block lg:hidden xl:hidden"
        style={{ position: 'fixed' }}
      />
    </div>
  )
}

export default Background
